import { useSetRecoilState } from "recoil"

import { ConsoleLogger } from "../util/logger"
import { AppStatus, ErrorCode } from "../constants/enums"
import { useTranslation } from "react-i18next"
import {
  avatarsAtom,
  avatarsErrorMessageAtom,
  avatarsLoading,
  avatarsSelector
} from "../recoil/atoms/avatars"
import React from "react"
import { SDKContext } from "./SDKContext"
import { appUserIdAtom } from "../recoil/atoms/app_user"
import { AvatarConfig } from "src/recoil/atoms/avatars/types"

const logger = new ConsoleLogger()

type useAvatarEventsCBProps = {
  onAvatarsConnect: (resp: any) => void
  onAvatarsMessage: (resp: any) => void
  onAvatarsError: (errorData: any) => void
}

export const useAvatarEventsCB = (): useAvatarEventsCBProps => {
  const { t } = useTranslation()
  const setAvatars = useSetRecoilState(avatarsSelector)
  const setAppUserId = useSetRecoilState(appUserIdAtom)
  const setAvatarsError = useSetRecoilState(avatarsErrorMessageAtom)
  const setAvatarsLoading = useSetRecoilState(avatarsLoading)
  const meetingClient = React.useContext(SDKContext)

  const onAvatarsConnect = resp => {
    setAppUserId(resp.userId)
    // meetingClient?.nativeBridge.eventSetAppUserID({appUserID: resp.userId})
    // console.log(meetingClient.nativeBridge.eventSetAppUserID)
    // if (meetingClient.nativeBridge.eventSetAppUserID != null) {
      // meetingClient?.nativeBridge.eventSetAppUserID({appUserID: resp.userId})
      
    // }
  }

  /** Handle on show message from the server */
  const onAvatarsMessage = avatarsData => {
    const queryParams = new URLSearchParams(window.location.search)
    const internalTest = queryParams.get("internalTest")
    logger.log("onAvatarsMessage", avatarsData);
    let sortedAvatars: AvatarConfig[] = avatarsData?.avatars?.sort((a, b) => a.position - b.position);
    const firstAvatar = avatarsData?.avatars[0]
    if (firstAvatar && internalTest) {
      // add the debug avatars
      // iOS native utta, iOS browser
      const testAvatars = [

        {
          name: "ThreeJS",
          description: "ThreeJS",
          url: "https://rohit-kadam-springct.github.io/trulience-assets/html/3j.html",
          avatarsId: "1",
          useDH: false,
          additionalArgs: [],
          useDebugUrl: true
        },

        {
          name: "ThreeJs Controller",
          description: "DHL",
          url: "https://rohit-kadam-springct.github.io/trulience-assets/html/3j-controller.html",
          avatarsId: "8195143338025043140",
          useDH: false,
          additionalArgs: [],
          useDebugUrl: true
        },

        {
          name: "Aframe parallel load",
          description: "DHL",
          url: "https://rohit-kadam-springct.github.io/trulience-assets/html/aframe-3j.html",
          avatarsId: "8195143338025043140",
          useDH: false,
          additionalArgs: [],
          useDebugUrl: true
        },
        
        {
          name: "link-21",
          description: "DHL",
          url: "https://sa-utils.agora.io/af2/21.html",
          avatarsId: "8195143338025043140",
          useDH: false,
          additionalArgs: [],
          useDebugUrl: true
        },
        {
          name: "link-22",
          description: "DHL",
          url: "https://sa-utils.agora.io/af2/22.html",
          avatarsId: "8195143338025043140",
          useDH: false,
          additionalArgs: [],
          useDebugUrl: true
        },
        {
          name: "DHL",
          description: "DHL",
          url: "https://trulience.com/avatar/8195143338025043140",
          avatarsId: "8195143338025043140",
          useDH: false,
          additionalArgs: [],
          useDebugUrl: false
        },
        {
          name: "DH Ava avatar",
          description: "Ava Full",
          url: "https://digitalhuman.uk/avatar/8894442580937032295",
          avatarsId: "8894442580937032295",
          useDH: true,
          additionalArgs: [],
          useDebugUrl: false
        },
        {
          name: "Dh avatar",
          description: "Alex Full",
          url: "https://digitalhuman.uk/avatar/721775738165938282",
          avatarsId: "721775738165938282",
          useDH: true,
          additionalArgs: [],
          useDebugUrl: false
        },
        {
          name: "Cars",
          description: "",
          url: "https://alteredqualia.com/three/examples/materials_cars.html",
          useDebugUrl: true,
          additionalArgs: []
        },
        {
          name: "Quake 3",
          description: "",
          url: "https://media.tojicode.com/q3bsp",
          useDebugUrl: true,
          additionalArgs: []
        },
        {
          name: "inverse kinematics scene",
          description: "",
          url: "https://threejs.org/examples/#webgl_animation_skinning_ik",
          useDebugUrl: true,
          additionalArgs: []
        },
        {
          name: "lego, demanding",
          description: "",
          url: "https://threejs.org/examples/#webgl_renderer_pathtracer",
          useDebugUrl: true,
          additionalArgs: []
        },
        {
          name: "dancing anims",
          description: "",
          url: "https://threejs.org/examples/#webgpu_animation_retargeting",
          useDebugUrl: true,
          additionalArgs: []
        },
        {
          name: "human",
          description: "",
          url: "https://threejs.org/examples/#webgl_decals",
          useDebugUrl: true,
          additionalArgs: []
        },
        // {
        //   name: "Alex Current",
        //   description: "",
        //   url: "https://digitalhuman.uk/avatar/2839001230507592489"
        // },
        // {
        //   name: "Alex Simple Env Simple Lights No Nips",
        //   description: "",
        //   url: "https://digitalhuman.uk/avatar/594424030448012076"
        // },
        // {
        //   name: "Alex No Env",
        //   description: "Should have a plain white BG with html.",
        //   url: "https://digitalhuman.uk/avatar/6630506776776295855"
        // },
        // {
        //   name: "Alex Simple Simple Env",
        //   description:
        //     "with flat color no env textures. Should have a plain grey color.",
        //   url: "https://digitalhuman.uk/avatar/186434278606979704"
        // },
        // {
        //   name: "Alex no lights in scene",
        //   description:
        //     "The skin is slightly visible, the material is slightly emissive to fake skin SSS. Rest of the clothing should be black without any lights.",
        //   url: "https://digitalhuman.uk/avatar/8772295719513703342"
        // },
        // {
        //   name: "Alex No Env No Nips",
        //   description:
        //     "",
        //   url: "https://digitalhuman.uk/avatar/4719240910556711656"
        // },
        // {
        //   name: "Alex Full No Nips",
        //   description:
        //     "",
        //   url: "https://digitalhuman.uk/avatar/4972132861893887272"
        // },
        // {
        //   name: "Alex Full No Shadows",
        //   description:
        //     "",
        //   url: "https://digitalhuman.uk/avatar/5052644162221392854"
        // },
        // {
        //   name: "Jean Original",
        //   description:
        //     "Shadows cast on floor but not on Jean",
        //   url: "https://digitalhuman.uk/avatar/5052644162221392854",
        //   additionalArgs: ['Tests=true', 'Conf=jean_cc_env']
        // },
        // {
        //   name: "RPM_env",
        //   description:
        //     "",
        //   url: "https://digitalhuman.uk/avatar/8894442580937032295",
        //   additionalArgs: ['Tests=true','Conf=RPM_env']
        // },
        // separate
        // {
        //   name: "HiPoly",
        //   description:
        //     "",
        //   url: "https://digitalhuman.uk/avatar/6053869711509966673",
        //   additionalArgs: []
        // },
        // {
        //   name: "HiPolyHiResTex",
        //   description:
        //     "",
        //   url: "https://digitalhuman.uk/avatar/4104275170454358529",
        //   additionalArgs: []
        // },
        // {
        //   name: "AlexDecLowResTex",
        //   description:
        //     "Decimated the model from 102k to 33.4k tris. Reduced the 2k textures for the face to 1k textures. 2k Environment",
        //   url: "https://digitalhuman.uk/avatar/8181325776894577359",
        //   additionalArgs: []
        // },
        // separate
        // {
        //   name: "2D Alex New Loading Sequence",
        //   description: "",
        //   url: "https://digitalhuman.uk/avatar/2839001230507592489",
        //   additionalArgs: []
        // },
        // {
        //   name: "3D Alex New Loading Sequence",
        //   description: "",
        //   url: "https://digitalhuman.uk/avatar/1842065365391723143",
        //   additionalArgs: []
        // },
        // {
        //   name: "Decimated Alex",
        //   description: "",
        //   url: "https://digitalhuman.uk/avatar/5226797622550612254",
        //   additionalArgs: []
        // },
        // {
        //   name: "Link 20 from Ben's page",
        //   description: "",
        //   url: "https://sa-utils.agora.io/af2/20.html",
        //   useDebugUrl: true,
        //   additionalArgs: []
        // },
        // {
        //   name: "Cars",
        //   description: "",
        //   url: "https://alteredqualia.com/three/examples/materials_cars.html",
        //   useDebugUrl: true,
        //   additionalArgs: []
        // },
        // {
        //   name: "Quake 3",
        //   description: "",
        //   url: "https://media.tojicode.com/q3bsp",
        //   useDebugUrl: true,
        //   additionalArgs: []
        // },
        // {
        //   name: "Hi poly RPM with 4k environment",
        //   description: "",
        //   url: "https://digitalhuman.uk/avatar/6053869711509966673",
        //   // useDebugUrl: true,
        //   additionalArgs: []
        // },
        // {
        //   name: "Hi poly+ Hi res Textures with 4k environment",
        //   description: "",
        //   url: "https://digitalhuman.uk/avatar/4104275170454358529",
        //   // useDebugUrl: true,
        //   additionalArgs: []
        // },
        // {
        //   name: "Alex Decimated Compressed with gltfReport",
        //   description: "Decimated the model from 102k to 33.4k tris. Reduced the 2k textures for the face to 1k textures. 4k Environment",
        //   url: "https://digitalhuman.uk/avatar/6013318414394672487",
        //   // useDebugUrl: true,
        //   additionalArgs: []
        // },
        // {
        //   name: "Alex Full Compressed with gltfReport. 4k Environment",
        //   description: "Alex Full Compressed with gltfReport. 4k Environment",
        //   // url: "https://digitalhuman.uk/avatar/66285419909958132", // old, doesn't work
        //   url: "https://digitalhuman.uk/avatar/8478842537132968857",
        //   // useDebugUrl: true,
        //   additionalArgs: []
        // },
        // {
        //   name: "Stable? Alex Full Compressed with GltfPack. 4K env",
        //   description: "Alex Full Compressed with GltfPack. 4K env",
        //   // url: "https://digitalhuman.uk/avatar/66285419909958132", // old, doesn't work
        //   url: "https://digitalhuman.uk/avatar/5725623304901774900",
        //   // useDebugUrl: true,
        //   additionalArgs: []
        // },
        // {
        //   name: "Damaru's link",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios",
        //   useDebugUrl: true,
        //   additionalArgs: ['connect=true']
        // },


        ///////////////////////////// SEPARATE  /////////////////////
        // {
        //   name: "glb gltfReport",
        //   description: "Alex Full Compressed into .glb with gltfReport",
        //   url: "https://digitalhuman.uk/avatar/8478842537132968857",
        //   avatarsId: "8478842537132968857",
        //   useDH: true
        // },
        // {
        //   name: "glb gltfPack",
        //   description: "Alex Full Compressed into .glb with gltfPack.",
        //   url: "https://digitalhuman.uk/avatar/5725623304901774900",
        //   avatarsId: "5725623304901774900",
        //   useDH: true
        // },
        // {
        //   name: "Alex Dec GltfReport",
        //   description: "Alex Decimated glb GltfReport",
        //   url: "https://digitalhuman.uk/avatar/4387658315835918748",
        //   avatarsId: "4387658315835918748",
        //   useDH: true,
        //   additionalArgs: [],
        //   useDebugUrl: false
        // },
        // {
        //   name: "DH avatar",
        //   description: "random dh avatar",
        //   url: "https://digitalhuman.uk/avatar/6305984608412912649",
        //   avatarsId: "6305984608412912649",
        //   useDH: true
        // },
        // {
        //   name: "aa=true,model=0,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=0&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=0,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=0&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=1,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=1&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=1,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=1&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=2,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=2&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=2,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=2&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=3,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=3&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=3,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=3&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=4,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=4&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=true,model=4,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=true&model=4&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=0,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=0&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=0,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=0&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=1,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=1&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=1,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=1&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=2,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=2&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=2,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=2&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=3,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=3&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=3,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=3&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=4,shadows=true",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=4&shadows=true",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // },
        // {
        //   name: "aa=false,model=4,shadows=false",
        //   description: "",
        //   url: "https://digitalhuman.uk/sdk/examples/test-ios/?aa=false&model=4&shadows=false",
        //   additionalArgs: ["connect=true"],
        //   useDebugUrl: true
        // }
      ]

      testAvatars.reverse()
      for (const testAvatar of testAvatars) {
        const urlSplit = testAvatar.url.split('/')
        const avatarId = urlSplit[urlSplit.length - 1]
        const debugAvatar: AvatarConfig = {...firstAvatar, avatarId, avatarId3d: avatarId, avatarName: testAvatar.name, avatarDescription: testAvatar.description, useDH: testAvatar.useDH, additionalArgs: testAvatar.additionalArgs, debugUrl: testAvatar.url, useDebugUrl: testAvatar.useDebugUrl }
        sortedAvatars = [debugAvatar, ...sortedAvatars]
      }
    }
    avatarsData.avatars = sortedAvatars

    setAvatars(avatarsData)
    setAvatarsLoading(false)
  }

  /** Handle error message from shows socket connections   */
  const onAvatarsError = errorData => {
    logger.log("onAvatarsError ===> ", errorData, AppStatus.SERVER_ERROR)

    // Three know type of error
    // - Invalid domain
    // - Operation not available
    // - Socket disconnect
    if (errorData.code === AppStatus.SERVER_ERROR) {
      let error = null

      switch (errorData.error.code) {
        // Handle invalid domain error
        case ErrorCode.InvalidDomain:
          error = {
            title: t("Invalid Domain!"),
            message: t("Invalid Domain Message")
          }
          break

        // Handle invalid operation error - occur if admin set show gird to No
        case ErrorCode.InvalidOperation:
          error = {
            title: t("Operation Unavailable"),
            message: t("Operation Unavailable Message")
          }
          break

        // If some other error occur
        default:
          error = {
            title: t("Oops, An Error Occurred"),
            message: t("Something Went Wrong Message")
          }
      }
      setAvatarsError(error)
      setAvatarsLoading(false)
    }
  }

  return {
    onAvatarsConnect,
    onAvatarsMessage,
    onAvatarsError,
  }
}
